/* Product Card In-Place Morphing Add to Cart & Stepper (- 1 +) JS */
(() => {
  if (document.documentElement.dataset.productCardInitialized === 'true') return;
  document.documentElement.dataset.productCardInitialized = 'true';

  const rootUrl = window.Shopify?.routes?.root || '/';

  // Helper to fetch current cart and sync product card stepper UI across the page
  let syncTimer = null;
  const syncCartState = () => {
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(async () => {
      try {
        const res = await fetch(`${rootUrl}cart.js?_t=${Date.now()}`, { cache: 'no-store' });
        if (!res.ok) return;
        const cart = await res.json();

        // Immediately sync outside header cart badge
        if (cart && typeof cart.item_count !== 'undefined') {
          document.querySelectorAll('[data-cart-count], .kb-header__badge--cart, .kb-header__action--cart .kb-header__badge').forEach((badge) => {
            badge.textContent = String(cart.item_count);
          });
        }

      // Create map of variantId -> quantity
      const cartVariantQtyMap = {};
      cart.items.forEach((item) => {
        cartVariantQtyMap[item.variant_id] = item.quantity;
      });

      // Update all product forms on page
      document.querySelectorAll('[data-product-card-form]').forEach((form) => {
        const card = form.closest('[data-product-card]');
        const select = card ? card.querySelector('[data-product-card-variant-select]') : null;
        let variantInput = form.querySelector('[name="id"]');
        if (select) {
          if (!variantInput) {
            variantInput = document.createElement('input');
            variantInput.type = 'hidden';
            variantInput.name = 'id';
            form.appendChild(variantInput);
          }
          variantInput.value = select.value;
        }
        if (!variantInput) return;
        const variantId = parseInt(variantInput.value, 10);
        const qtyInCart = cartVariantQtyMap[variantId] || 0;

        const addBtn = form.querySelector('[data-card-add-btn]');
        const stepper = form.querySelector('[data-card-inline-stepper]');
        const countSpan = form.querySelector('[data-inline-count]');
        const container = form.querySelector('[data-card-btn-container]');

        const selectedOption = select ? select.selectedOptions[0] : null;

        let isAvail = true;
        if (select && selectedOption) {
          const optText = (selectedOption.textContent || '').toLowerCase();
          const isDataUnavail = selectedOption.dataset.available === 'false';
          const isZeroInv = selectedOption.dataset.inventory !== undefined && parseInt(selectedOption.dataset.inventory, 10) <= 0;
          if (selectedOption.disabled || isDataUnavail || isZeroInv || optText.includes('sold out') || optText.includes('out of stock')) {
            isAvail = false;
          }
        } else {
          const isBtnDisabled = addBtn ? (addBtn.hasAttribute('disabled') || addBtn.disabled) : false;
          const isDataUnavailable = form.dataset.available === 'false';
          const labelText = (addBtn?.textContent || '').toLowerCase();
          if (isDataUnavailable || isBtnDisabled || labelText.includes('sold out') || labelText.includes('out of stock')) {
            isAvail = false;
          }
        }

        if (!isAvail) {
          form.classList.remove('is-in-cart');
          if (container) container.classList.remove('is-in-cart');
          if (stepper) stepper.style.setProperty('display', 'none', 'important');
          if (addBtn) {
            addBtn.style.setProperty('display', 'flex', 'important');
            addBtn.disabled = true;
            addBtn.setAttribute('disabled', 'disabled');
            addBtn.style.setProperty('opacity', '0.65', 'important');
            addBtn.style.setProperty('cursor', 'not-allowed', 'important');
            const labelSpan = addBtn.querySelector('span');
            if (labelSpan) labelSpan.textContent = 'SOLD OUT';
            else addBtn.textContent = 'SOLD OUT';
          }
        } else if (qtyInCart > 0 && stepper && addBtn && countSpan) {
          form.classList.add('is-in-cart');
          if (container) container.classList.add('is-in-cart');
          addBtn.style.setProperty('display', 'none', 'important');
          stepper.style.setProperty('display', 'flex', 'important');
          countSpan.textContent = String(qtyInCart);

          // Sync sticky mobile bar quantity value if on main product form
          if (form.matches('[data-product-main-form]')) {
            const stickyQtyVal = document.querySelector('[data-sticky-quantity-val]');
            if (stickyQtyVal) stickyQtyVal.textContent = String(qtyInCart);
          }
        } else if (stepper && addBtn) {
          form.classList.remove('is-in-cart');
          if (container) container.classList.remove('is-in-cart');
          stepper.style.setProperty('display', 'none', 'important');
          addBtn.style.setProperty('display', 'flex', 'important');
          addBtn.disabled = false;
          addBtn.removeAttribute('disabled');
          addBtn.style.setProperty('opacity', '1', 'important');
          addBtn.style.setProperty('cursor', 'pointer', 'important');
          const labelSpan = addBtn.querySelector('span');
          if (labelSpan) labelSpan.textContent = 'ADD TO CART';
        }
      });
    } catch (e) {
      console.error('Cart sync error:', e);
    }
    }, 40);
  };

  // 1. Listen for Form Submissions (Clicking ADD TO CART)
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-card-form]');
    if (!form) return;

    event.preventDefault();

    const card = form.closest('[data-product-card]');
    const select = card ? card.querySelector('[data-product-card-variant-select]') : null;
    let variantInput = form.querySelector('[name="id"]');
    if (select) {
      if (!variantInput) {
        variantInput = document.createElement('input');
        variantInput.type = 'hidden';
        variantInput.name = 'id';
        form.appendChild(variantInput);
      }
      variantInput.value = select.value;
    }

    const addBtn = form.querySelector('[data-card-add-btn]');
    const stepper = form.querySelector('[data-card-inline-stepper]');
    const countSpan = form.querySelector('[data-inline-count]');
    const container = form.querySelector('[data-card-btn-container]');

    if (addBtn) addBtn.disabled = true;

    try {
      const addUrl = form.action.replace(/\/cart\/add(?:\.js)?$/, '/cart/add.js');
      const response = await fetch(addUrl, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });

      if (!response.ok) throw new Error('Failed to add item to cart');

      // Morph button into [- 1 +] stepper in-place
      if (addBtn && stepper && countSpan) {
        form.classList.add('is-in-cart');
        if (container) container.classList.add('is-in-cart');
        addBtn.style.setProperty('display', 'none', 'important');
        stepper.style.setProperty('display', 'flex', 'important');
        countSpan.textContent = '1';
      }

      // Fetch updated cart, dispatch custom event, and open cart drawer / navigate to cart
      const cleanRoot = rootUrl.replace(/\/$/, '');
      const cartRes = await fetch(`${cleanRoot}/cart.js?_t=${Date.now()}`);
      const updatedCart = await cartRes.json();
      document.dispatchEvent(new CustomEvent('kb:cart:updated', { detail: { cart: updatedCart } }));
      
      if (typeof window.openDrawer === 'function') {
        window.openDrawer(updatedCart);
      } else {
        window.location.href = `${cleanRoot}/cart`;
      }
    } catch (err) {
      console.error(err);
    } finally {
      if (addBtn) addBtn.disabled = false;
    }
  });

  // 2. Listen for In-Place Stepper Plus / Minus Clicks
  document.addEventListener('click', async (event) => {
    // Quick view
    const quickView = event.target.closest('[data-quick-view]');
    if (quickView) {
      document.dispatchEvent(new CustomEvent('greenbasket:quick-view', { detail: { url: quickView.dataset.productUrl } }));
    }

    const inlineBtn = event.target.closest('[data-inline-plus], [data-inline-minus]');
    if (!inlineBtn) return;

    event.preventDefault();
    const form = inlineBtn.closest('[data-product-card-form]');
    if (!form) return;

    const variantInput = form.querySelector('[name="id"]');
    if (!variantInput) return;
    const variantId = String(variantInput.value);

    const stepper = form.querySelector('[data-card-inline-stepper]');
    const addBtn = form.querySelector('[data-card-add-btn]');
    const countSpan = form.querySelector('[data-inline-count]');
    const container = form.querySelector('[data-card-btn-container]');
    let currentQty = parseInt(countSpan?.textContent || '1', 10);

    let nextQty = currentQty;
    if (inlineBtn.hasAttribute('data-inline-plus')) {
      nextQty = currentQty + 1;
    } else if (inlineBtn.hasAttribute('data-inline-minus')) {
      nextQty = currentQty - 1;
    }

    if (nextQty <= 0) {
      // Remove item from cart -> Morph back to ADD TO CART button
      form.classList.remove('is-in-cart');
      if (container) container.classList.remove('is-in-cart');
      stepper.style.setProperty('display', 'none', 'important');
      addBtn.style.setProperty('display', 'flex', 'important');

      try {
        const changeRes = await fetch(`${rootUrl}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 0 })
        });
        const updatedCart = await changeRes.json();
        document.dispatchEvent(new CustomEvent('kb:cart:updated', { detail: { cart: updatedCart } }));
      } catch (err) {
        console.error('Error removing item:', err);
      }
    } else {
      // Update quantity in cart silently
      if (countSpan) countSpan.textContent = String(nextQty);

      try {
        const changeRes = await fetch(`${rootUrl}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: nextQty })
        });
        const updatedCart = await changeRes.json();
        document.dispatchEvent(new CustomEvent('kb:cart:updated', { detail: { cart: updatedCart } }));
        if (window.showCartToast) window.showCartToast(updatedCart);
      } catch (err) {
        console.error('Error updating quantity:', err);
      }
    }
  });

  // 3. Variant Select Change Listener
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-product-card-variant-select]');
    if (!select) return;

    const card = select.closest('[data-product-card]');
    if (!card) return;

    const option = select.selectedOptions[0];
    const price = card.querySelector('.product-card__price-current');
    const compare = card.querySelector('.product-card__price-compare');
    const add = card.querySelector('[data-card-add-btn]');

    if (price && option?.dataset.price) price.textContent = option.dataset.price;
    if (compare) {
      const compVal = option?.dataset.compare;
      if (compVal && compVal.trim() !== '' && compVal !== option.dataset.price) {
        compare.textContent = compVal;
        compare.style.display = 'block';
      } else {
        compare.style.display = 'none';
      }
    }
    const optText = (option?.textContent || '').toLowerCase();
    const isDataUnavail = option?.dataset?.available === 'false';
    const isZeroInv = option?.dataset?.inventory !== undefined && parseInt(option.dataset.inventory, 10) <= 0;
    const isAvailable = option && !option.disabled && !isDataUnavail && !isZeroInv && !optText.includes('sold out') && !optText.includes('out of stock');
    const form = card.querySelector('[data-product-card-form]');
    if (form) {
      let variantInput = form.querySelector('[name="id"]');
      if (!variantInput) {
        variantInput = document.createElement('input');
        variantInput.type = 'hidden';
        variantInput.name = 'id';
        form.appendChild(variantInput);
      }
      variantInput.value = select.value;
    }
    const addBtn = card.querySelector('[data-card-add-btn]');
    const stepper = card.querySelector('[data-card-inline-stepper]');
    const container = card.querySelector('[data-card-btn-container]');

    if (!isAvailable) {
      if (form) form.classList.remove('is-in-cart');
      if (container) container.classList.remove('is-in-cart');
      if (stepper) stepper.style.setProperty('display', 'none', 'important');
      if (addBtn) {
        addBtn.style.setProperty('display', 'flex', 'important');
        addBtn.disabled = true;
        addBtn.setAttribute('disabled', 'disabled');
        addBtn.style.setProperty('opacity', '0.65', 'important');
        addBtn.style.setProperty('cursor', 'not-allowed', 'important');
        const labelSpan = addBtn.querySelector('span');
        if (labelSpan) labelSpan.textContent = 'SOLD OUT';
        else addBtn.textContent = 'SOLD OUT';
      }
    } else {
      if (addBtn) {
        addBtn.disabled = false;
        addBtn.removeAttribute('disabled');
        addBtn.style.setProperty('opacity', '1', 'important');
        addBtn.style.setProperty('cursor', 'pointer', 'important');
        const labelSpan = addBtn.querySelector('span');
        if (labelSpan) labelSpan.textContent = 'ADD TO CART';
      }
    }

    // Dynamic Variant Badge Update
    const badgeText = option?.dataset.badge;
    let badgeEl = card.querySelector('.product-card__title-badge');
    let badgeWrap = card.querySelector('[data-card-badge-container]');
    if (badgeText && badgeText.trim() !== '') {
      if (!badgeEl) {
        if (!badgeWrap) {
          badgeWrap = document.createElement('div');
          badgeWrap.className = 'product-card__title-badge-wrap';
          badgeWrap.setAttribute('data-card-badge-container', '');
          const titleRow = card.querySelector('.product-card__title-row');
          if (titleRow) {
            titleRow.parentNode.insertBefore(badgeWrap, titleRow.nextSibling);
          } else {
            const content = card.querySelector('.product-card__content');
            if (content) content.insertBefore(badgeWrap, content.firstChild);
          }
        }
        badgeEl = document.createElement('span');
        badgeEl.className = 'product-card__title-badge';
        badgeWrap.appendChild(badgeEl);
      }
      badgeEl.textContent = badgeText.trim();
      if (badgeWrap) badgeWrap.style.setProperty('display', 'flex', 'important');
      badgeEl.style.setProperty('display', 'inline-flex', 'important');
    } else {
      if (badgeEl) {
        badgeEl.style.setProperty('display', 'none', 'important');
        badgeEl.textContent = '';
      }
      if (badgeWrap) {
        badgeWrap.style.setProperty('display', 'none', 'important');
      }
    }

    // Ensure any promotional badge above product image is removed
    const topPromoBadge = card.querySelector('.product-card__top-bar .product-card__badge:not(.product-card__badge--sold), .product-card__media .product-card__badge:not(.product-card__badge--sold)');
    if (topPromoBadge) topPromoBadge.remove();

    // Sync stepper state for newly selected variant
    syncCartState();
  });

  // Ensure variant with badge is selected by default if not already
  const syncDefaultBadgeVariants = () => {
    document.querySelectorAll('[data-product-card]').forEach((card) => {
      const select = card.querySelector('[data-product-card-variant-select]');
      if (!select || !select.options || select.options.length <= 1) return;
      const currentOption = select.options[select.selectedIndex] || select.selectedOptions[0];
      if (!currentOption || !currentOption.dataset.badge || currentOption.dataset.badge.trim() === '') {
        const options = Array.from(select.options);
        const targetOption = options.find((opt) => opt.dataset.badge && opt.dataset.badge.trim() !== '' && opt.dataset.available !== 'false')
          || options.find((opt) => opt.dataset.badge && opt.dataset.badge.trim() !== '');
        if (targetOption && targetOption !== currentOption) {
          select.value = targetOption.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  };

  const initCartSync = () => {
    cleanupTopBarBadges();
    syncDefaultBadgeVariants();
    syncCartState();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartSync);
  } else {
    initCartSync();
  }
  document.addEventListener('kb:cart:updated', syncCartState);

  // Automatically resync card steppers and badges on browser back/forward and tab focus
  window.addEventListener('pageshow', () => {
    syncDefaultBadgeVariants();
    syncCartState();
  });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      syncCartState();
    }
  });
})();
